module.exports = __webpack_public_path__ + "img/IT0000807584025.4ae63377.png";